import React from 'react'
import { ExamOnlineListPage } from 'components/exam_online'

export const ExamOnlineList = () => {
  return <ExamOnlineListPage />
}
